import React from 'react'
import NavBar from '../Components/Main/NavBar'
import CartItem from '../Components/Cart/CartItem'
import { useNavigate } from 'react-router-dom'
import '../css/Cart/cart.css'
import { useContext } from 'react'
import { CartContext } from '../Context/CartProvider'

const Cart = () => {
    const navigate = useNavigate()
    const {cart} = useContext(CartContext);
    const {price} = useContext(CartContext);
    const {count} = useContext(CartContext);

    const proceed = () => {
      if (count > 0) {
        navigate('/fizetes/szallitas')  
      }      
    }
  return (
    <div>
        <NavBar/>
        <div className="cart-container">
            <h1>Kosár</h1>
            <div className='cart-items-container'>
              {cart.length > 0 ? (
                cart.map((item) => (
                  <CartItem key={item.id} item={item}/>
              ))
              ) : (
                <h2>Nincs termék a kosárba</h2>
              )}
            </div>
            <div className='cart-total-price'>
              <h1>Összesen:</h1>
              <h1>{price} Ft</h1>
            </div>
            <button onClick={proceed}>Tovább a pénztárhoz</button>
        </div>
    </div>
  )
}

export default Cart